var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 43 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5391 10.6641C11.5391 5.14121 16.0162 0.664062 21.5391 0.664062C27.0618 0.664062 31.5391 5.14121 31.5391 10.6641V28.1641C31.5391 33.6868 27.0618 38.1641 21.5391 38.1641C16.0162 38.1641 11.5391 33.6868 11.5391 28.1641V10.6641Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16406 27.7734V28.1639C7.16406 31.9764 8.67856 35.6327 11.3744 38.3287C14.0702 41.0244 17.7266 42.5389 21.5391 42.5389C25.3516 42.5389 29.0078 41.0244 31.7038 38.3287C34.3996 35.6327 35.9141 31.9764 35.9141 28.1639V27.7734C35.9141 26.3927 37.0333 25.2734 38.4141 25.2734H39.6641C41.0448 25.2734 42.1641 26.3927 42.1641 27.7732V28.1639C42.1641 33.6339 39.9911 38.8802 36.1231 42.7479C32.9996 45.8717 28.9773 47.8897 24.6641 48.5509V53.1639C24.6641 54.5447 23.5448 55.6639 22.1641 55.6639H20.9141C19.5333 55.6639 18.4141 54.5447 18.4141 53.1639V48.5509C14.1008 47.8897 10.0785 45.8717 6.95499 42.7479C3.08704 38.8802 0.914062 33.6339 0.914062 28.1639V27.7734C0.914062 26.3927 2.03336 25.2734 3.41406 25.2734H4.66406C6.04476 25.2734 7.16406 26.3927 7.16406 27.7734Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.297d30465ba204f9592988e32b5c0615.svg";
export { ForwardRef as ReactComponent };